/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Conflict_ReloadedInputs */

const en_toast_conflict_reloaded = /** @type {(inputs: Toast_Conflict_ReloadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changed by someone else. Reloaded.`)
};

const de_toast_conflict_reloaded = /** @type {(inputs: Toast_Conflict_ReloadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Von jemand anderem geändert. Neu geladen.`)
};

/**
* | output |
* | --- |
* | "Changed by someone else. Reloaded." |
*
* @param {Toast_Conflict_ReloadedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const toast_conflict_reloaded = /** @type {((inputs?: Toast_Conflict_ReloadedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Conflict_ReloadedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_toast_conflict_reloaded(inputs)
	return en_toast_conflict_reloaded(inputs)
});